import { createFileRoute, Outlet } from "@tanstack/react-router";

import { FounderLayout } from "@/founder/FounderLayout";

export const Route = createFileRoute("/founder")({
    head: () => ({
        meta: [{ name: "robots", content: "noindex, nofollow" }],
    }),
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <FounderLayout>
            <Outlet />
        </FounderLayout>
    );
}
